import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

//import MUI
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import ExitToApp from "@mui/icons-material/ExitToApp";
import Backdrop from "@mui/material/Backdrop";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import LoginIcon from "@mui/icons-material/Login";
import PersonIcon from "@mui/icons-material/Person";

// import icons
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import NewspaperIcon from "@mui/icons-material/Newspaper";

function Footer(props) {
  // redux hooks
  const { auth } = useSelector((state) => state.customerAuth);

  const location = useLocation();

  const [openSpeed, setOpenSpeed] = React.useState(false);
  const handleOpen = () => setOpenSpeed(!openSpeed);
  const handleClose = () => setOpenSpeed(!openSpeed);

  const { logOut } = props;

  const actions = [
    {
      icon: <ExitToApp onClick={logOut} className="text-danger" />,
      name: "خروج از سیستم",
    },
    {
      icon: (
        <Link to="/search">
          <ManageSearchIcon className="text-success" />
        </Link>
      ),
      name: " جستجوی طرح ها",
    },
  ];
  const selectedMenu = (route) => {
    return location.pathname === route ? `text-danger` : "text-dark";
  };
  return (
    <>
      {" "}
      <div className="row">
        <div className="col-12" style={{ zIndex: 5001 }}>
          {" "}
          <div className="container-fluid">
            <div className="row fixed-bottom">
              <div className="col-12 px-0">
                <div className="topFooterShape"></div>
              </div>
            </div>
            <div className="row footer fixed-bottom">
              <div className="col-12">
                <div className="row mx-0 justify-content-between py-2">
                  <div className="col px-0 text-center">
                    {auth.isAuthenticated ? (
                      <Link
                        onClick={() => props.setIsOpenMobileMenu(true)}
                        className={selectedMenu("/profile")}
                      >
                        <PersonIcon />
                        <p className="footer-link">پروفایل</p>
                      </Link>
                    ) : (
                      <Link to="/login" className={selectedMenu("/login")}>
                        <LoginIcon />
                        <p className="footer-link"> ورود</p>
                      </Link>
                    )}
                  </div>
                  <div className="col px-0 text-center">
                    <Link to="/blog" className={selectedMenu("/blog")}>
                      <NewspaperIcon />
                      <p className="footer-link">بلاگ</p>
                    </Link>
                  </div>
                  <div className="col px-0 text-center">
                    {auth.isAuthenticated ? (
                      <Link to="/basket" className={selectedMenu("/basket")}>
                        <ShoppingCartIcon />
                        <p className="footer-link">سبد خرید</p>
                      </Link>
                    ) : (
                      <Link to="/login" className={selectedMenu("/basket")}>
                        <ShoppingCartIcon />
                        <p className="footer-link">سبد خرید</p>
                      </Link>
                    )}
                  </div>
                  <div className="col px-0 text-center">
                    <Link to="/search" className={selectedMenu("/search")}>
                      <SearchIcon />
                      <p className="footer-link">جستجو</p>
                    </Link>
                  </div>
                  <div className="col px-0 text-center">
                    <Link to="/" className={selectedMenu("/")}>
                      <HomeIcon />
                      <p className="footer-link">خانه</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop open={openSpeed} />
      <SpeedDial
        ariaLabel="دسترسی سریع"
        sx={{ position: "fixed", bottom: 60, right: 10 }}
        icon={<SpeedDialIcon />}
        onClick={handleOpen}
        open={openSpeed}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={handleClose}
          />
        ))}
      </SpeedDial>
    </>
  );
}

export default Footer;
